export default __webpack_public_path__ + "static/media/youtube.7672ddee.png";